'use strict';

/**
 * Calculates the maximum number of slides (from the last to the first)
 * that can fit within the container's width.
 * @param {HTMLCollection} $containerSelector - The selector for the container
 * @param {HTMLCollection} minusWith - Minus width
 * @returns {number} - The number of slides (from last to first) that can fit
 */
function calculateMaxSlidesFit($containerSelector, minusWith = 0) {
    var containerWidth = $containerSelector.width() - minusWith;
    var totalWidth = 0;
    var slidesFit = 0;

    // Loop through the children in reverse order (from last to first)
    $($containerSelector)
        .children()
        .get()
        .reverse()
        .every(function (element) {
            var slideWidth = $(element).outerWidth(true);
            totalWidth += slideWidth;
            if (totalWidth <= containerWidth) {
                slidesFit += 1;
                return true;
            }
            return false;
        });

    return slidesFit;
}

const filter = {
    initCarousel: function () {
        $('.filter-appliedflts-slider').each(function () {
            if ($(this).hasClass('slick-initialized')) {
                $(this).slick('unslick');
            }
            const $sliderWrapper = $(this).closest('.filter-appliedflts-wrapper');
            const totalSlidesWidth = $(this)
                .children()
                .toArray()
                .reduce((totalWidth, slide) => {
                    return totalWidth + $(slide).outerWidth(true);
                }, 0);
            const containerWidth = $(this).width();

            if (totalSlidesWidth > containerWidth) {
                var minusWith = 0;
                if ($(this).closest('.filter-wrapper').length) {
                    minusWith = $sliderWrapper.find('.filter-slick-arrow').width();
                }

                if ($(this).closest('.refinements-footer').length) {
                    minusWith = -30;
                }

                var slidesToShow = calculateMaxSlidesFit($(this), minusWith) || 1;
                $(this).slick({
                    variableWidth: true,
                    arrows: true,
                    infinite: false,
                    speed: 500,
                    slidesToShow: slidesToShow,
                    touchThreshold: 1000,
                    slidesToScroll: 1,
                    nextArrow: $sliderWrapper.find('.slick-next'),
                    prevArrow: $sliderWrapper.find('.slick-prev'),
                });
            }
        });
    },
    init: function () {
        const $document = $(document);
        const $window = $(window);

        $document.on('initializeFilterCarousel', function () {
            filter.initCarousel();
        });

        $window.on('orientationchange', function () {
            filter.initCarousel();
        });

        $document.on('click', '.filter-opener', function () {
            setTimeout(function () {
                filter.initCarousel();
            }, 0);
        });
    },
};

module.exports = filter;
